import { Outlet } from 'react-router-dom'
import goleroLogo from '@/assets/images/golero-logo.svg'
import { useAuth } from '@/auth/AuthContext'
import { LanguagePicker } from '@/components/LanguagePicker'
import { useDomTranslations, useTranslation } from '@/i18n'

export function RegistrationLayout() {
  useDomTranslations()
  const { signOut } = useAuth()
  const { t } = useTranslation()

  return (
    <div className="relative min-h-screen bg-[#02060c] text-white">
      <div
        className="absolute inset-0"
        style={{
          background:
            'repeating-linear-gradient(0deg, transparent 0 72px, rgba(216,220,220,0.025) 72px 73px), repeating-linear-gradient(90deg, transparent 0 72px, rgba(216,220,220,0.025) 72px 73px), linear-gradient(135deg, #0a0d10 0%, #0d1114 48%, #07090b 100%)',
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(circle at 50% -12%, rgba(216,220,220,0.035), transparent 42%), linear-gradient(180deg, transparent 54%, rgba(7,9,13,0.9) 100%)',
        }}
      />

      <div className="relative z-10 min-h-screen px-4 py-6 sm:px-6 sm:py-8 lg:px-10">
        <header className="mx-auto flex w-full max-w-6xl items-center justify-between">
          <img src={goleroLogo} alt="Golero" className="h-7 w-auto" />
          <div className="flex items-center gap-2">
            <LanguagePicker compact />
            <button
              type="button"
              onClick={() => void signOut()}
              className="rounded-full border border-surface-700 px-4 py-1.5 text-xs font-semibold text-surface-300 transition hover:border-surface-500 hover:text-white"
            >
              {t('Uitloggen')}
            </button>
          </div>
        </header>

        <main className="mx-auto w-full max-w-6xl py-8 sm:py-10">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
